const PRINCETON_EMAIL_DOMAIN = "@princeton.edu";

export const normalizeEmail = (email = "") => email.trim().toLowerCase();

export const isPrincetonEmail = (email = "") =>
  normalizeEmail(email).endsWith(PRINCETON_EMAIL_DOMAIN);

export const canAccessApplications = (email = "", hackathonStatus = "") => {
  const normalizedStatus = `${hackathonStatus}`.trim().toLowerCase();

  return (
    normalizedStatus === "open" ||
    (normalizedStatus === "closed" && isPrincetonEmail(email))
  );
};
